// extracted by mini-css-extract-plugin
module.exports = {"page":"page__1fj9B","body":"body__Ghncg","top-thumbnail":"top-thumbnail__2VYFT"};